'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ConversationHeaderInfo } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatConversationUtilityClasses } from "./chatConversationClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatConversationHeaderInfo');
const ChatConversationHeaderInfoStyled = styled('div', {
  name: 'MuiChatConversation',
  slot: 'HeaderInfo',
  overridesResolver: (_, styles) => styles.headerInfo
})(() => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  overflow: 'hidden'
}));
const ChatConversationHeaderInfo = /*#__PURE__*/React.forwardRef(function ChatConversationHeaderInfo(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatConversationHeaderInfo'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatConversationUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ConversationHeaderInfo, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      headerInfo: slots?.headerInfo ?? ChatConversationHeaderInfoStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      headerInfo: _extends({
        className: clsx(classes.headerInfo, className),
        sx
      }, slotProps?.headerInfo)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatConversationHeaderInfo.displayName = "ChatConversationHeaderInfo";
process.env.NODE_ENV !== "production" ? ChatConversationHeaderInfo.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatConversationHeaderInfo };